import common from 'app/locales/fr/common'
import origination from 'app/locales/fr/origination'
import portal from 'app/locales/fr/portal'
import prequal from 'app/locales/fr/prequal'

export default {
    ...common,
    ...prequal,
    ...origination,
    ...portal
}
